document.addEventListener("DOMContentLoaded", function() {
  const typingEffectContainer = document.getElementById("typing-effect-container");
  const searchInput = document.querySelector('.search-input');

  // Typing effect function
  function typeEffect(element, text, interval = 100) {
    let index = 0;
    element.textContent = ''; // Clear the container initially
    const typingInterval = setInterval(() => {
      if (index < text.length) {
        element.textContent += text[index++];
      } else {
        clearInterval(typingInterval);
      }
    }, interval);
  }

  // Trigger typing effect when search input is focused
  searchInput.addEventListener("focus", function() {
    typeEffect(typingEffectContainer, "I am looking for an intake kit for my 2019 Honda Civic TYPE-R. Please recommend me one.", 100);
  });
});
